import axiosClient from "api/apiClient";

export const APIGetNotificationsVerifyEmail = () => {
    return axiosClient.get(`/notifications/verify-email`);
};